<template>
  <section>
    <div>
      <b-modal
        :active="isModalNewEditProcessActive"
        aria-modal
        has-modal-card
        :destroy-on-hide="true"
        aria-role="dialog"
        width="100%"
        :can-cancel="['escape']"
      >
        <template>
          <ModalNewEditProcess
            modal-cancel="true"
            :update="updateProcess"
            :create="false"
            :proceed="proceedProcess"
            :processIdSelected="selectedProcessId"
            @close="
              isModalNewEditProcessActive = false;
              updateProcess = false;
              proceedProcess = false;
            "
            @refresh="setProcess()"
            @refreshProcess="refreshProcess"
          />
        </template>
      </b-modal>
    </div>

    <div class="container box mt-5">
      <div class="content mb-6 has-text-centered">
        <h1>Proceso de Evaluación Académica {{ year }}</h1>
        <h3 v-if="showFromUnit" class="mt-0">
          {{ unit.name }}
        </h3>
        <h3 class="mt-0">Fase Actual: {{ lastPhaseProcessName }}</h3>
        <div v-if="!(showFromUnit || showFromFaculty)" class="columns centered">
          <div class="column has-text-right">
            <b-button
              v-if="
                isProcessActive &&
                isAuthorized('PerformancePhaseUpdateProcessDates')
              "
              label="Editar Fase"
              type="is-warning"
              icon-left="edit"
              @click="
                isModalNewEditProcessActive = true;
                updateProcess = true;
              "
              @refresh="setProcess()"
            />
            <b-button
              v-if="
                isProcessActive &&
                isAuthorized('PerformancePhaseAdvanceProcess')
              "
              label="Avanzar Fase"
              icon-left="forward"
              @click="
                isModalNewEditProcessActive = true;
                proceedProcess = true;
              "
              @refresh="setProcess()"
            />
          </div>
        </div>
        <!--        <div class="columns">-->
        <!--          <div class="column has-text-right">-->
        <!--            <b-button-->
        <!--              :label="`Exportación de Datos`"-->
        <!--              icon-left="file-excel"-->
        <!--              type="is-info"-->
        <!--              tag="a"-->
        <!--              :href="'/performances/statistics-menu/' + year"-->
        <!--            />-->
        <!--          </div>-->
        <!--        </div>-->

        <!--        <div class="columns">
          <div class="column has-text-right">
            <b-button
                :label="`Ir a Dasboard de Datos`"
                icon-left="chart-pie"
                type="is-primary"
                tag="a"
                :href="'/performances/dashboard-performance/' + year"
            />
          </div>
        </div>-->
      </div>

      <div v-if="false" class="columns">
        <div class="column has-text-right">
          <b-button
            v-if="false"
            label="Ampliar Plazo de Declaración"
            type="is-purple-color-usach"
            icon-left="users-cog"
            tag="a"
            href="/extend_phase_terms"
            target="_blank"
          />
          <b-button
            v-if="false"
            label="Reportería de la Última Fase"
            type="is-primary"
            outlined
          />
        </div>
      </div>

      <div class="columns is-centered">
        <div class="column is-10 is-bordered-grey">
          <div class="columns mb-0">
            <div class="column">
              <div class="title is-5 has-text-centered">
                Fases de este Proceso
                <hr class="dropdown-divider" aria-role="menuitem" />
              </div>
            </div>
          </div>
          <b-table :data="data" striped>
            <b-table-column label="Fase" field="alt_name" v-slot="props">
              {{ props.row.alt_name }}
            </b-table-column>

            <b-table-column
              label="Fecha Inicio"
              field="start_date"
              v-slot="props"
            >
              {{
                props.row.is_started
                  ? new Date(props.row.start_date).toLocaleDateString("es-CL")
                  : "No Iniciada"
              }}
            </b-table-column>

            <b-table-column
              label="Fecha Término"
              field="end_date"
              v-slot="props"
            >
              {{
                props.row.is_started
                  ? new Date(props.row.end_date).toLocaleDateString("es-CL")
                  : "No Iniciada"
              }}
            </b-table-column>
          </b-table>
        </div>
      </div>

      <br />
      <br />

      <div class="columns">
        <div class="column">
          <div class="title is-4 has-text-centered">
            Evaluación Académica del Cuerpo Académico
            <hr class="dropdown-divider" aria-role="menuitem" />
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="title is-5">
            Filtros de Búsqueda
            <hr class="dropdown-divider" aria-role="menuitem" />
          </div>
        </div>
      </div>

      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(checkFilter)">
          <div class="columns mb-0">
            <ValidationProvider
              v-if="!showFromUnit"
              class="column"
              name="Unidad"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Unidad "
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <multiselect
                  v-model="filter.unit_id"
                  :options="units.map((type) => type.id)"
                  :custom-label="(opt) => units.find((x) => x.id === opt).name"
                  placeholder="Seleccione una Unidad"
                  selectLabel="Presione para seleccionar"
                  selectedLabel="Seleccionado"
                  deselectLabel="Presione para deseleccionar"
                  allow-empty
                >
                  <template v-slot:noOptions> No existen datos </template>
                  <span slot="noResult"> No se encontraron elementos. </span>
                </multiselect>
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              v-if="!showFromUnit"
              class="column is-2"
              name="Centro de Costo"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Centro de Costo "
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <b-input
                  v-model="filter.cost_center"
                  placeholder="Ingrese Centro de Costo"
                  type="number"
                  maxlength="5"
                />
              </b-field>
            </ValidationProvider>

            <div :class="showFromUnit ? 'column' : 'column is-3'">
              <b-field label="RUN">
                <ValidationProvider
                  name="RUT"
                  rules="integer|min:7|max:8"
                  v-slot="{ errors }"
                >
                  <b-input v-model="filter.rut" placeholder="Ej: 12345678" />
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>

            <div :class="showFromUnit ? 'column' : 'column is-2'">
              <b-field label="DV">
                <ValidationProvider
                  name="DV"
                  rules="min:1|max:1"
                  v-slot="{ errors }"
                >
                  <b-input
                    v-model="filter.dv"
                    placeholder="Ej: 1 o K"
                    maxlength="1"
                  />
                  <span>{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <ValidationProvider
              class="column"
              name="Primer Apellido"
              rules="min:3|max:255"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Primer Apellido"
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <b-input v-model="filter.last_name" placeholder="Ej: Solis" />
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              class="column"
              name="Segundo Apellido"
              rules="min:3|max:255"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Segundo Apellido"
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <b-input
                  v-model="filter.second_surname"
                  placeholder="Ej: Dominguez"
                />
              </b-field>
            </ValidationProvider>

            <ValidationProvider
              class="column"
              name="Nombres"
              rules="min:3|max:255"
              v-slot="{ errors, failedRules }"
            >
              <b-field
                label="Nombre"
                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''"
              >
                <b-input
                  v-model="filter.name"
                  placeholder="Ej: Felipe Cristian"
                />
              </b-field>
            </ValidationProvider>
          </div>

          <div class="columns">
            <div class="column has-text-right">
              <b-button
                v-if="haveFilters"
                label="Limpiar Filtros"
                icon-left="broom"
                type="is-warning is-light"
                @click="cleanFilters()"
              />
              <b-button
                label="Aplicar Filtros"
                icon-left="search"
                type="is-blue-color"
                @click="checkFilter()"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>

      <br />
      <br />

      <div v-if="isActiveFilter" class="columns">
        <div class="column">
          <div class="title is-5">
            Listado de las Declaraciones de desempeño del Cuerpo Académico
            <hr class="dropdown-divider" aria-role="menuitem" />
          </div>
        </div>
      </div>

      <!-- Selector de Fases Principal -->
      <b-tabs
        v-model="selectedPhase"
        v-if="isActiveFilter"
        type="is-toggle"
        position="is-centered"
        class="mb-4"
        @input="onPhaseChange"
      >
        <b-tab-item label="Fase 1" value="fase1" />
        <b-tab-item label="Fase 2" value="fase2" />
        <b-tab-item label="Fase 3" value="fase3" />
        <b-tab-item label="Fase 4" value="fase4" />
      </b-tabs>

      <!-- Título descriptivo de la fase seleccionada -->
      <div v-if="isActiveFilter && phaseTitle" class="has-text-centered mb-5">
        <h4 class="title is-5 has-text-primary">{{ phaseTitle }}</h4>
      </div>

      <!-- Filtros dinámicos según la fase seleccionada -->
      <b-tabs
        :key="`filter-tabs-${selectedPhase}`"
        v-model="filterBy"
        v-if="isActiveFilter"
        type="is-toggle"
        position="is-centered"
      >
        <!-- Filtros para Fase 1: Declaración de compromisos -->
        <template v-if="selectedPhase === 'fase1'">
          <b-tab-item label="Declaraciones Emitidas" value="EMITIDA" />
          <b-tab-item label="Declaraciones Aceptadas" value="ACEPTADA" />
          <b-tab-item label="Declaraciones En Curso" value="EN CURSO" />
          <b-tab-item label="Declaraciones No Iniciadas" value="notStarted" />
          <b-tab-item label="No Participa en el Proceso" value="canParticipate" />
        </template>

        <!-- Filtros para Fase 2: Verificación y subida de evidencias -->
        <template v-if="selectedPhase === 'fase2'">
          <b-tab-item label="Verificación enviada" value="VERIFICACION_ENVIADA" />
          <b-tab-item label="Verificación no enviada" value="VERIFICACION_NO_ENVIADA" />
        </template>

        <!-- Filtros para Fase 3: Precalificación -->
        <template v-if="selectedPhase === 'fase3'">
          <b-tab-item label="En Precalificación" value="EN PRECALIFICACION" />
          <b-tab-item label="Precalificadas" value="PRECALIFICADA" />
        </template>

        <!-- Filtros para Fase 4: Calificación -->
        <template v-if="selectedPhase === 'fase4'">
          <b-tab-item label="Sin filtros disponibles" value="no_filters" disabled />
        </template>
      </b-tabs>
      <b-table
        :data="filterAcademicPerformances"
        striped
        paginated
        per-page="10"
        :pagination-simple="false"
        pagination-position="bottom"
        aria-next-label="Siguiente"
        aria-previous-label="Anterior"
        aria-page-label="Página"
        aria-current-label="Página actual"
      >
        <b-table-column label="Nombre" field="academic_name" v-slot="props">
          {{ props.row.academic_name }}
        </b-table-column>

        <b-table-column label="Rut" field="academic_rut" v-slot="props">
          {{ props.row.academic_rut }}
        </b-table-column>

        <b-table-column
          :visible="!showFromUnit"
          label="Unidad"
          field="academic_unit_name"
          v-slot="props"
        >
          {{ props.row.academic_unit_name }}
        </b-table-column>

        <b-table-column
          :visible="!showFromUnit"
          label="CC"
          field="academic_unit_cost_center"
          v-slot="props"
        >
          {{ props.row.academic_unit_cost_center }}
        </b-table-column>

        <b-table-column
          label="Última Fase Ingresada"
          field="last_phase_alt_name"
          v-slot="props"
          :visible="filterBy !== 'canParticipate' && selectedPhase !== 'fase2'"
        >
          {{ props.row.last_phase_alt_name }}
        </b-table-column>

        <b-table-column
          label="Estado Verificación"
          field="verification_status"
          v-slot="props"
          :visible="selectedPhase === 'fase2'"
        >
          <span :class="getVerificationStatusClass(props.row)">
            {{ getVerificationStatusLabel(props.row) }}
          </span>
        </b-table-column>

        <b-table-column
          label="Función"
          field="function"
          v-slot="props"
          :visible="filterBy == 'canParticipate'"
        >
          {{ props.row.function ? props.row.function : "Académica/o" }}
        </b-table-column>

        <b-table-column
          label="Acciones"
          width="100"
          v-slot="props"
          :visible="filterBy !== 'canParticipate'"
        >
          <b-button
            type="is-primary"
            icon-left="eye"
            tag="a"
            :href="`/performances/process/${year}/person/${props.row.academic_id}`"
          />
        </b-table-column>

        <template slot="empty" slot-scope="props">
          <div class="columns is-centered">
            <div class="column is-6 is-centered has-text-centered">
              <b-message type="is-warning">
                No se han encontrado registros de Desempeños.
              </b-message>
            </div>
          </div>
        </template>
      </b-table>

      <b-loading v-model="isLoading" />
    </div>
  </section>
</template>

<script>
import moment from "moment";
import axios from "axios";
import ModalNewEditProcess from "./ModalNewEditProcess.vue";
import { filter } from "lodash";
export default {
  name: "ShowProcess",

  components: {
    ModalNewEditProcess,
  },

  computed: {
    // Título descriptivo de cada fase
    phaseTitle() {
      const titles = {
        fase1: 'Declaración de los compromisos de desempeño',
        fase2: 'Verificación y subida de evidencias',
        fase3: 'Precalificación',
        fase4: 'Calificación'
      };
      return titles[this.selectedPhase] || '';
    },
    
    filterAcademicPerformances() {
      if (!this.academicPerformances) {
        return [];
      }
      
      // Asegurar que el computed sea reactivo a selectedPhase
      const currentPhase = this.selectedPhase;
      const currentFilter = this.filterBy;
      
      // Filtros especiales
      if (currentFilter === "notStarted") {
        return this.academicPerformances.filter(
          (x) =>
            !x.is_emit &&
            !x.is_performance_declaration_in_last_phase &&
            x.can_participate
        );
      } else if (currentFilter === "canParticipate") {
        return this.academicPerformances.filter((x) => !x.can_participate);
      } else if (currentFilter === "no_filters") {
        // Para fases sin filtros, devolver array vacío
        return [];
      }
      
      // Filtros de verificación (Fase 2)
      if (currentFilter === "VERIFICACION_ENVIADA") {
        return this.academicPerformances.filter(
          (x) => x.verification_status === 'VERIFICACION_ENVIADA' && x.can_participate
        );
      } else if (currentFilter === "VERIFICACION_NO_ENVIADA") {
        // Solo mostrar académicos que SÍ declararon pero aún no envían verificación
        return this.academicPerformances.filter(
          (x) => x.verification_status === 'VERIFICACION_NO_ENVIADA' && 
                 x.can_participate &&
                 x.id !== null  // Tiene declaración (performance existe)
        );
      }
      
      // Filtro especial para ACEPTADA: mostrar todas las declaraciones que fueron aceptadas en Fase 1
      // independientemente de su estado actual (para que no desaparezcan al avanzar de fase)
      if (currentFilter === "ACEPTADA") {
        return this.academicPerformances.filter(
          (x) => x.was_accepted_in_phase_1 === true && x.can_participate
        );
      }
      
      // Filtro por estado
      return this.academicPerformances.filter(
        (x) => x.state === currentFilter || x.state === "SIN ESTADO"
      );
    },
  },

  props: {
    year: {
      type: Number,
      required: true,
    },
    last_phase: {
      type: String,
      required: true,
    },
    permissions: {
      type: Array,
      required: false,
    },
    showFromUnit: {
      type: Boolean,
      required: false,
      default: false,
    },
    unit: {
      type: Object,
      required: false,
    },
    showFromFaculty: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      //Auxiliar variables
      isLoading: false,
      isModalNewEditProcessActive: false,
      selectedProcessId: null,
      isProcessActive: false,
      updateProcess: false,
      proceedProcess: false,
      isActiveFilter: false,
      haveFilters: false,

      //Data for table
      data: [],

      //Data from API
      process: [],
      units: [],
      phases_types: [],
      academicPerformances: [],
      lastPhaseProcessName: null,

      //Filters
      filter: {
        unit_id: null,
        cost_center: null,
        run: null,
        dv: null,
        last_name: null,
        second_surname: null,
        name: null,
      },
      selectedPhase: "fase1", // Fase seleccionada por defecto
      filterBy: "EMITIDA",
      // Filtros por defecto para cada fase
      defaultFiltersByPhase: {
        fase1: "EMITIDA",
        fase2: "VERIFICACION_ENVIADA",
        fase3: "EN PRECALIFICACION",
        fase4: "no_filters"
      }
    };
  },
  async created() {
    this.lastPhaseProcessName = this.last_phase;
    await this.setProcess();
    if (!this.showFromUnit) await this.getUnits();
    await this.getAcademicPerformances();
  },
  watch: {
    // Observar cambios en filterBy para debugging
    filterBy(newVal) {
      console.log('filterBy cambió a:', newVal);
    }
  },
  methods: {
    // Método para obtener la etiqueta del estado de verificación
    getVerificationStatusLabel(row) {
      const statusLabels = {
        'VERIFICACION_ENVIADA': 'Enviada',
        'VERIFICACION_NO_ENVIADA': 'No enviada',
        'SIN_ACTIVIDADES': 'Sin actividades',
        'SIN_DECLARACION': 'Sin declaración'
      };
      return statusLabels[row.verification_status] || row.verification_status;
    },
    
    // Método para obtener la clase CSS del estado de verificación
    getVerificationStatusClass(row) {
      const statusClasses = {
        'VERIFICACION_ENVIADA': 'has-text-success has-text-weight-semibold',
        'VERIFICACION_NO_ENVIADA': 'has-text-danger has-text-weight-semibold',
        'SIN_ACTIVIDADES': 'has-text-grey',
        'SIN_DECLARACION': 'has-text-grey-light'
      };
      return statusClasses[row.verification_status] || '';
    },
    
    // Método para manejar el cambio de fase
    onPhaseChange(newPhase) {
      console.log('Fase cambiada a:', newPhase);
      // Aplicar el filtro por defecto de la fase seleccionada
      this.filterBy = this.defaultFiltersByPhase[newPhase];
      console.log('Nuevo filterBy:', this.filterBy);
    },
    
    isAuthorized(name) {
      let permission = this.permissions.find((obj) => obj.name === name);
      if (permission !== undefined) {
        return permission.value;
      } else {
        return false;
      }
    },

    async getProcess() {
      this.isLoading = true;
      await axios
        .get("/performance_phases/process/" + this.year + ".json")
        .then((response) => {
          this.process = response.data;
          this.process.forEach((element) => {
            element.start_date = moment(element.start_date, [
              "YYYY-MM-DD",
              "DD-MM-YYYY",
            ]);
            element.end_date = moment(element.end_date, [
              "YYYY-MM-DD",
              "DD-MM-YYYY",
            ]);
          });
          this.lastPhaseProcessName =
            this.process[this.process.length - 1].phase_d_type.alt_name;
          this.isProcessActive = this.process.length < 4;
          this.selectedProcessId = this.process.slice(-1)[0].id;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar obtener los datos. Intente más tarde",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async getTypePhases() {
      this.isLoading = true;
      await axios
        .get("/phase_d_types.json")
        .then((response) => {
          this.phases_types = response.data;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar obtener los datos. Intente más tarde",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
          this.$emit("close");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async setProcess() {
      this.data = [];
      await this.getProcess();
      await this.getTypePhases();

      this.phases_types.forEach((element) => {
        let phase = this.process.find((x) => x.phase_d_type.id === element.id);

        element.start_date = phase ? phase.start_date : null;
        element.end_date = phase ? phase.end_date : null;
        element.is_started = phase ? true : false;

        this.data.push(element);
      });
    },

    refreshProcess(process) {
      this.phases_types.forEach((element) => {
        if (element.id === process.phase_d_type_id) {
          element.start_date = moment(process.start_date, [
            "YYYY-MM-DD",
            "DD-MM-YYYY",
          ]);
          element.end_date = moment(process.end_date, [
            "YYYY-MM-DD",
            "DD-MM-YYYY",
          ]);
          return;
        }
      });
    },

    async getUnits() {
      this.isLoading = true;
      await axios
        .get("/units/get-departments-of-engineering-faculty.json")
        .then((response) => {
          this.units = response.data;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar obtener los datos. Intente más tarde",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async checkFilter() {
      let valid = await this.$refs.observer.validate();
      if (!valid) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Algunos campos presentan errores.",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
        return;
      }

      this.haveFilters = !Object.values(this.filter).every(
        (value) => value === null
      );

      await this.getAcademicPerformances();
    },

    async cleanFilters() {
      this.filter = {
        unit_id: null,
        cost_center: null,
        run: null,
        dv: null,
        last_name: null,
        second_surname: null,
        name: null,
      };
      this.haveFilters = false;
      await this.getAcademicPerformances();
    },

    async getAcademicPerformances() {
      this.isLoading = true;
      if (this.showFromUnit) this.filter.unit_id = this.unit.id;
      await axios
        .get("/performances/get-by-academic-filters.json", {
          params: {
            process_year: this.year,
            ...this.filter,
          },
        })
        .then((response) => {
          this.academicPerformances = response.data;
          this.isActiveFilter = true;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al intentar obtener los datos. Intente más tarde",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => {
          if (this.showFromUnit) this.filter.unit_id = null;
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
/* Estilos para el selector de fases principal */
.mb-4 {
  margin-bottom: 1.5rem;
}

.mb-5 {
  margin-bottom: 2rem;
}

/* Mejorar la separación visual entre los tabs de fase y los filtros */
.b-tabs .tab-content {
  padding-top: 1rem;
}

/* Estilo para los tabs de fase principal */
.b-tabs:first-of-type {
  border-bottom: 2px solid #dbdbdb;
  padding-bottom: 0.5rem;
  margin-bottom: 1.5rem;
}

/* Estilo para el título de la fase */
.title.is-5.has-text-primary {
  background-color: #f5f5f5;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  border-left: 4px solid #3273dc;
}
</style>
